export const TAGS = {
  Task: 'TSK',
  Partfield: 'PFD',
  OperTechPractice: 'OTP',
  CulturalPractice: 'CPC',
  Worker: 'WKR',
  WorkerAllocation: 'WAN',
  Grid: 'GRD',
  TreatmentZone: 'TZN',
  ProcessDataVariable: 'PDV',
  ValuePresentation: 'VPN',
  Polygon: 'PLN',
  LineString: 'LSG',
  Point: 'PNT',
  Time: 'TIM',
  Product: 'PDT',
  ProductAllocation: 'PAN',
  Farm: 'FRM',
  AttachedFile: 'AFE',
  Link: 'LNK',
  LinkGroup: 'LGP',
  AllocationStamp: 'ASP',
  BaseStation: 'BSN',
  CodedComment: 'CCT',
  CodedCommentGroup: 'CCG',
  CodedCommentListValue: 'CCL',
  ColourLegend: 'CLD',
  ColourRange: 'CRG',
  CommentAllocation: 'CAN',
  Connection: 'CNN',
  ControlAssignment: 'CAT',
  CropType: 'CTP',
  CropVariety: 'CVT',
  Customer: 'CTR',
  DataLogTrigger: 'DLT',
  DataLogValue: 'DLV',
  Device: 'DVC',
  DeviceAllocation: 'DAN',
  DeviceElement: 'DET',
  DeviceObjectReference: 'DOR',
  DeviceProcessData: 'DPD',
  DeviceProperty: 'DPT',
  DeviceValuePresentation: 'DVP',
  GuidanceAllocation: 'GAN',
  GuidanceGroup: 'GGP',
  GuidancePattern: 'GPN',
  GuidanceShift: 'GST',
  ISO11783_TaskData: 'ISO11783_TaskData',
  OperationTechnique: 'OTQ',
  OperationTechniqueReference: 'OTR',
  Position: 'PTN',
  ProductGroup: 'PGP',
  ProductRelation: 'PRN',
  TaskControllerCapabilities: 'TCC',
  TimeLog: 'TLG',
  ExternalFileContents: 'XFC',
  ExternalFileReference: 'XFR',
};

export const ATTRS = {
  Task: {
    TaskId: 'A',
    TaskDesignator: 'B',
    CustomerIdRef: 'C',
    FarmIdRef: 'D',
    PartfieldIdRef: 'E',
    ResponsibleWorkerIdRef: 'F',
    TaskStatus: 'G',
    DefaultTreatmentZoneCode: 'H',
    PositionLostTreatmentZoneCode: 'I',
    OutOfFieldTreatmentZoneCode: 'J',
  },

  AllocationStamp: {
    Start: 'A',
    Stop: 'B',
    Duration: 'C',
    Type: 'D',
  },

  BaseStation: {
    BaseStationId: 'A',
    BaseStationDesignator: 'B',
    BaseStationNorth: 'C',
    BaseStationEast: 'D',
    BaseStationUp: 'E',
  },

  CodedComment: {
    CodedCommentId: 'A',
    CodedCommentDesignator: 'B',
    CodedCommentScope: 'C',
    CodedCommentGroupIdRef: 'D',
  },

  CodedCommentGroup: {
    CodedCommentGroupId: 'A',
    CodedCommentGroupDesignator: 'B',
  },

  CodedCommentListValue: {
    CodedCommentListValueId: 'A',
    CodedCommentListValueDesignator: 'B',
  },

  ColourLegend: {
    ColourLegendId: 'A',
    DefaultColour: 'B',
  },

  ColourRange: {
    MinimumValue: 'A',
    MaximumValue: 'B',
    Colour: 'C',
  },

  CommentAllocation: {
    CodedCommentIdRef: 'A',
    CodedCommentListValueIdRef: 'B',
    FreeCommentText: 'C',
  },

  Connection: {
    DeviceIdRef_0: 'A',
    DeviceElementIdRef_0: 'B',
    DeviceIdRef_1: 'C',
    DeviceElementIdRef_1: 'D',
  },

  ControlAssignment: {
    SourceClientNAME: 'A',
    UserClientNAME: 'B',
    SourceDeviceStructureLabel: 'C',
    UserDeviceStructureLabel: 'D',
    SourceDeviceElementNumber: 'E',
    UserDeviceElementNumber: 'F',
    ProcessDataDDI: 'G',
  },

  CropType: {
    CropTypeId: 'A',
    CropTypeDesignator: 'B',
    ProductGroupIdRef: 'C',
  },

  CropVariety: {
    CropVarietyId: 'A',
    CropVarietyDesignator: 'B',
    ProductIdRef: 'C',
  },

  Customer: {
    CustomerId: 'A',
    CustomerLastName: 'B',
    CustomerFirstName: 'C',
    CustomerStreet: 'D',
    CustomerPOBox: 'E',
    CustomerPostalCode: 'F',
    CustomerCity: 'G',
    CustomerState: 'H',
  },

  DataLogTrigger: {
    DataLogDDI: 'A',
    DataLogMethod: 'B',
    DataLogDistanceInterval: 'C',
    DataLogTimeInterval: 'D',
    DataLogThresholdMinimum: 'E',
    DataLogThresholdMaximum: 'F',
    DataLogThresholdChange: 'G',
    DeviceElementIdRef: 'H',
    ValuePresentationIdRef: 'I',
    DataLogPGN: 'J',
    DataLogPGNStartBit: 'K',
    DataLogPGNStopBit: 'L',
  },

  DataLogValue: {
    ProcessDataDDI: 'A',
    ProcessDataValue: 'B',
    DeviceElementIdRef: 'C',
    DataLogPGN: 'D',
    DataLogPGNStartBit: 'E',
    DataLogPGNStopBit: 'F',
  },

  Device: {
    DeviceId: 'A',
    DeviceDesignator: 'B',
    DeviceSoftwareVersion: 'C',
    ClientNAME: 'D',
    DeviceSerialNumber: 'E',
    DeviceStructureLabel: 'F',
    DeviceLocalizationLabe: 'G',
  },

  DeviceAllocation: {
    ClientNAMEValue: 'A',
    ClientNAMEMask: 'B',
    DeviceIdRef: 'C',
  },

  DeviceElement: {
    DeviceElementId: 'A',
    DeviceElementObjectId: 'B',
    DeviceElementType: 'C',
    DeviceElementDesignator: 'D',
    DeviceElementNumber: 'E',
    ParentObjectId: 'F',
  },

  DeviceObjectReference: {
    DeviceObjectId: 'A',
  },

  DeviceProcessData: {
    DeviceProcessDataObjectId: 'A',
    DeviceProcessDataDDI: 'B',
    DeviceProcessDataProperty: 'C',
    DeviceProcessDataTriggerMethods: 'D',
    DeviceProcessDataDesignator: 'E',
    DeviceValuePresentationObjectId: 'F',
  },

  DeviceProperty: {
    DevicePropertyObjectId: 'A',
    DevicePropertyDDI: 'B',
    DevicePropertyValue: 'C',
    DevicePropertyDesignator: 'D',
    DeviceValuePresentationObjectId: 'E',
  },

  DeviceValuePresentation: {
    DeviceValuePresentationObjectId: 'A',
    Offset: 'B',
    Scale: 'C',
    NumberOfDecimals: 'D',
    UnitDesignator: 'E',
  },

  GuidanceAllocation: {
    GuidanceGroupIdRef: 'A',
  },

  GuidanceGroup: {
    GuidanceGroupId: 'A',
    GuidanceGroupDesignator: 'B',
  },

  GuidancePattern: {
    GuidancePatternId: 'A',
    GuidancePatternDesignator: 'B',
    GuidancePatternType: 'C',
    GuidancePatternOptions: 'D',
    GuidancePatternPropagationDirection: 'E',
    GuidancePatternExtension: 'F',
    GuidancePatternHeading: 'G',
    GuidancePatternRadius: 'H',
    GuidancePatternGNSSMethod: 'I',
    GuidancePatternHorizontalAccuracy: 'J',
    GuidancePatternVerticalAccuracy: 'K',
    BaseStationIdRef: 'L',
    OriginalSRID: 'M',
    NumberOfSwathsLeft: 'N',
    NumberOfSwathsRight: 'O',
  },

  GuidanceShift: {
    GuidanceGroupIdRef: 'A',
    GuidancePatternIdRef: 'B',
    GuidanceEastShift: 'C',
    GuidanceNorthShift: 'D',
    PropagationOffset: 'E',
  },

  OperationTechnique: {
    OperationTechniqueId: 'A',
    OperationTechniqueDesignator: 'B',
  },

  OperationTechniqueReference: {
    OperationTechniqueIdRef: 'A',
  },

  Position: {
    PositionNorth: 'A',
    PositionEast: 'B',
    PositionUp: 'C',
    PositionStatus: 'D',
    PDOP: 'E',
    HDOP: 'F',
    NumberOfSatellites: 'G',
    GpsUtcTime: 'H',
    GpsUtcDate: 'I',
  },

  ProductGroup: {
    ProductGroupId: 'A',
    ProductGroupDesignator: 'B',
    ProductGroupType: 'C',
  },

  ProductRelation: {
    ProductIdRef: 'A',
    QuantityValue: 'B',
  },

  TaskControllerCapabilities: {
    TaskControllerControlFunctionNAME: 'A',
    TaskControllerDesignator: 'B',
    VersionNumber: 'C',
    ProvidedCapabilities: 'D',
    NumberOfBoomsSectionControl: 'E',
    NumberOfSectionsSectionControl: 'F',
    NumberOfControlChannels: 'G',
  },

  TimeLog: {
    Filename: 'A',
    Filelength: 'B',
    TimeLogType: 'C',
  },

  ExternalFileReference: {
    Filename: 'A',
    Filetype: 'B',
  },

  Partfield: {
    PartfieldId: 'A',
    PartfieldCode: 'B',
    PartfieldDesignator: 'C',
    PartfieldArea: 'D',
    CustomerIdRef: 'E',
    FarmIdRef: 'F',
    CropTypeIdRef: 'G',
    CropVarietyIdRef: 'H',
    FieldIdRef: 'I',
  },

  OperTechPractice: {
    CulturalPracticeIdRef: 'A',
    OperationTechniqueIdRef: 'B',
  },

  CulturalPractice: {
    CulturalPracticeId: 'A',
    CulturalPracticeDesignator: 'B',
  },

  Worker: {
    WorkerId: 'A',
    WorkerLastName: 'B',
    WorkerFirstName: 'C',
    WorkerStreet: 'D',
    WorkerPOBox: 'E',
    WorkerPostalCode: 'F',
    WorkerCity: 'G',
    WorkerState: 'H',
    WorkerCountry: 'I',
    WorkerPhone: 'J',
    WorkerMobile: 'K',
    WorkerLicenseNumber: 'L',
    WorkerEmail: 'M',
  },

  WorkerAllocation: {
    WorkerIdRef: 'A',
    AllocationStamp: 'B',
  },

  Grid: {
    GridMinimumNorthPosition: 'A',
    GridMinimumEastPosition: 'B',
    GridCellNorthSize: 'C',
    GridCellEastSize: 'D',
    GridMaximumColumn: 'E',
    GridMaximumRow: 'F',
    Filename: 'G',
    Filelength: 'H',
    GridType: 'I',
    TreatmentZoneCode: 'J',
  },

  TreatmentZone: {
    TreatmentZoneCode: 'A',
    TreatmentZoneDesignator: 'B',
    TreatmentZoneColour: 'C',
  },

  ProcessDataVariable: {
    ProcessDataDDI: 'A',
    ProcessDataValue: 'B',
    ProductIdRef: 'C',
    DeviceElementIdRef: 'D',
    ValuePresentationIdRef: 'E',
    ActualCulturalPracticeValue: 'F',
    ElementTypeInstanceValue: 'G',
  },

  ValuePresentation: {
    ValuePresentationId: 'A',
    Offset: 'B',
    Scale: 'C',
    NumberOfDecimals: 'D',
    UnitDesignator: 'E',
    ColourLegendIdRef: 'F',
  },

  Polygon: {
    PolygonType: 'A',
    PolygonDesignator: 'B',
    PolygonArea: 'C',
    PolygonColour: 'D',
    PolygonId: 'E',
  },

  LineString: {
    LineStringType: 'A',
    LineStringDesignator: 'B',
    LineStringWidth: 'C',
    LineStringLength: 'D',
    LineStringColour: 'E',
    LineStringId: 'F',
  },

  Point: {
    PointType: 'A',
    PointDesignator: 'B',
    PointNorth: 'C',
    PointEast: 'D',
    PointUp: 'E',
    PointColour: 'F',
    PointId: 'G',
    PointHorizontalAccuracy: 'H',
    PointVerticalAccuracy: 'I',
    Filename: 'J',
    Filelength: 'K',
  },

  Time: {
    Start: 'A',
    Stop: 'B',
    Duration: 'C',
    Type: 'D',
  },

  Product: {
    ProductId: 'A',
    ProductDesignator: 'B',
    ProductGroupIdRef: 'C',
    ValuePresentationIdRef: 'D',
    QuantityDDI: 'E',
    ProductType: 'F',
    MixtureRecipeQuantity: 'G',
    DensityMassPerVolume: 'H',
    DensityVolumePerCount: 'I',
    DensityMassPerCount: 'J',
  },

  ProductAllocation: {
    ProductIdRef: 'A',
    QuantityDDI: 'B',
    QuantityValue: 'C',
    TransferMode: 'D',
    DeviceElementIdRef: 'E',
    ValuePresentationIdRef: 'F',
  },

  Farm: {
    FarmId: 'A',
    FarmDesignator: 'B',
    FarmStreet: 'C',
    FarmPOBox: 'D',
    FarmPostalCode: 'E',
    FarmCity: 'F',
    FarmState: 'G',
    FarmCountry: 'H',
    CustomerIdRef: 'I',
  },

  AttachedFile: {
    FilenameWithExtension: 'A',
    Preserve: 'B',
    ManufacturerGLN: 'C',
    FileType: 'D',
    FileVersion: 'E',
    FileLength: 'F',
  },

  Link: {
    ObjectIdRef: 'A',
    LinkValue: 'B',
    LinkDesignator: 'C',
  },

  LinkGroup: {
    LinkGroupId: 'A',
    LinkGroupType: 'B',
    ManufacturerGLN: 'C',
    LinkGroupNamespace: 'D',
    LinkGroupDesignator: 'E',
  },
};

export const DATA_TRANSFER_ORIGINS = {
  FMIS: '1',
  MICS: '2',
};

export const TASK_STATUSES = {
  planned: '1',
  running: '2',
  paused: '3',
  completed: '4',
  template: '5',
  canceled: '6',
};

export const GRID_TYPES = {
  TYPE_1: '1',
  TYPE_2: '2',
};

export const POLYGON_TYPES = {
  PartfieldBoundary: '1',
  TreatmentZone: '2',
  WaterSurface: '3',
  Building: '4',
  Road: '5',
  Obstacle: '6',
  Flag: '7',
  Other: '8',
  Mainfield: '9',
  Headland: '10',
  BufferZone: '11',
  Windbreak: '12',
};

export const LINESTRING_TYPES = {
  PolygonExterior: '1',
  PolygonInterior: '2',
  TramLine: '3',
  SamplingRoute: '4',
  GuidancePattern: '5',
  Drainage: '6',
  Fence: '7',
  Flag: '8',
  Obstacle: '9',
};

export const POINT_TYPES = {
  Flag: '1',
  Other: '2',
  Field: '3',
  Storage: '4',
  Obstacle: '5',
  GuidanceReferenceA: '6',
  GuidanceReferenceB: '7',
  GuidanceReferenceCenter: '8',
  GuidancePoint: '9',
  PartfieldReferencePoint: '10',
  Homebase: '11',
};

export const TIME_TYPES = {
  Planned: '1',
  Preliminary: '2',
  Effective: '4',
  Ineffective: '5',
  Repair: '6',
  Clearing: '7',
  PoweredDown: '8',
};
export const ALLOCATION_STAMP_TYPES = {
  Planned: '1',
  Effective: '4',
};

export const PRODUCT_TYPES = {
  Single: '1',
  Mixture: '2',
  TemporaryMixture: '3',
};

export const LINK_GROUP_TYPES = {
  UUIDs: '1',
  ManufacturerProprietary: '2',
  UniqueResolvableURIs: '3',
  InformationalResolvableURIs: '4',
};

export const ATTACHED_FILE_PRESERVE = {
  DoNotPreserve: '1',
  Preserve: '2',
};

export const ATTACHED_FILE_FILE_TYPES = {
  Linklist: '1',
};

export const TIMELOG_TYPES = {
  BinaryTimeLogFile: '1',
};

export const DATA_LOG_TRIGGER_METHODS = {
  TimeInterval: 1,
  DistanceInterval: 2,
  ThresholdLimits: 4,
  OnChange: 8,
  Total: 16,
};

export const DDI = {
  SetpointVolumePerAreaApplicationRate: '0001', // mm³/m², 0.01
  SetpointMassPerAreaApplicationRate: '0006',
  SetpointVolumePerTimeApplicationRate: '0024',
  SetpointMassPerTimeApplicationRate: '0029',
  SetpointCountContent: '004D',
  ActualVolumeContent: '0048',
  ActualMassContent: '004B',
  ActualCountContent: '004E',
  PGNBasedData: 'DFFE',
  RequestDefaultProcessData: 'DFFF',
};
